import React from 'react';

import { useTheme } from '../../context/ThemeContext';

interface TypeScriptLogoProps {}

export const TypeScriptLogo = ({ ...props }: TypeScriptLogoProps) => {
  const { activeTheme } = useTheme();
  return (
    <>
      <div className="logo-container">
        <svg
          width="100"
          height="100"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M99.9707 0H0.0292969C0.0131167 0 0 0.0131167 0 0.0292969V99.9707C0 99.9869 0.0131167 100 0.0292969 100H99.9707C99.9869 100 100 99.9869 100 99.9707V0.0292969C100 0.0131167 99.9869 0 99.9707 0Z"
            fill={activeTheme === 'light' ? '#2F2F3A' : '#ffffff'}
          />
          <path
            d="M45.5078 55.4688H58.0078V47.4609H23.0469V55.4688H35.5469V91.2109H45.5078V55.4688ZM61.9141 89.2578C63.4961 90.0781 65.4297 90.6836 67.5781 91.0938C69.7266 91.5039 72.0703 91.6992 74.4141 91.6992C76.7578 91.6992 78.9062 91.4844 81.0547 91.0352C83.2031 90.5859 84.9609 89.8438 86.5234 88.8867C88.1055 87.8516 89.4531 86.543 90.2344 84.7852C91.0156 83.0273 91.6211 81.0742 91.6211 78.5352C91.6211 76.7578 91.3477 75.2148 90.8203 73.8477C90.293 72.4805 89.5312 71.3086 88.4766 70.332C87.4805 69.2969 86.3281 68.3789 84.9609 67.5977C83.5938 66.8164 82.0312 65.9961 80.2734 65.2539C78.9844 64.7266 77.9297 64.2188 76.7578 63.7109C75.7422 63.2031 74.8633 62.6953 74.2188 62.1875C73.4961 61.6602 72.9492 61.1133 72.5586 60.5469C72.168 59.9609 71.9727 59.3164 71.9727 58.5938C71.9727 57.9297 72.1465 57.3242 72.5 56.7773C72.8535 56.2305 73.3398 55.7813 73.9648 55.3906C74.5898 55 75.3711 54.707 76.3086 54.4922C77.2266 54.2773 78.2422 54.1797 79.4336 54.1797C80.2539 54.1797 81.1133 54.2402 81.9727 54.3633C82.8711 54.4863 83.7891 54.6758 84.707 54.9297C85.625 55.1836 86.5234 55.4961 87.4414 55.8867C88.3008 56.2773 89.1016 56.7266 89.7852 57.2344V48.0547C88.3008 47.4883 86.6602 47.0586 84.9023 46.7852C83.1445 46.5117 81.1914 46.375 78.8477 46.375C76.5039 46.375 74.3555 46.6289 72.207 47.1172C70.0586 47.6055 68.3008 48.3867 66.7383 49.4609C65.1563 50.5156 64.0039 51.8047 63.0273 53.5625C62.1094 55.2031 61.6602 57.0781 61.6602 59.4219C61.6602 62.3516 62.5 64.8906 64.1992 66.8437C65.8789 68.9922 68.4961 70.5547 71.8164 72.1172C73.1641 72.6641 74.3555 73.2109 75.5273 73.7383C76.6992 74.2656 77.6758 74.8125 78.457 75.3789C79.2969 75.9453 79.9609 76.5703 80.4102 77.2344C80.8984 77.8984 81.1523 78.6797 81.1523 79.5781C81.1523 80.2031 81 80.7891 80.7031 81.3359C80.4063 81.8828 79.9414 82.3516 79.3164 82.7422C78.6914 83.1328 77.9297 83.4453 76.9727 83.6797C76.0547 83.8945 75.0195 84.0117 73.6523 84.0117C71.5039 84.0117 69.3555 83.6406 67.4023 82.8984C65.2539 82.1562 63.3008 81.043 61.9141 79.8828V89.2578Z"
            fill={activeTheme === 'light' ? '#EDF2FA' : '#2F2F3A'}
          />
        </svg>

        <p style={{ color: activeTheme === 'light' ? '#2F2F3A' : '#ffffff' }}>
          TypeScript
        </p>
      </div>
    </>
  );
};

export default TypeScriptLogo;
